import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { FuseConfigService } from '@fuse/services/config.service';
import {TranslateLoader, TranslateModule, TranslateService} from "@ngx-translate/core";
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { WebCompProfileService } from 'app/main/pagina/web-comp-profile/web-comp-profile.service';
import *  as $ from 'jquery';
import { lang_surveyStatusV2 } from 'app/idiomas/i18n/survey-status-v2/survey-status-v2.lang';
@Component({
  selector: 'app-exter-web-com-profile',
  templateUrl: './exter-web-com-profile.component.html',
  styleUrls: ['./exter-web-com-profile.component.scss']
})
export class ExterWebComProfileComponent implements OnInit {
empresID:any;
wcpValidado:boolean=false;
visibleWCP:number=0;
accesoWcp="";
urlWebComProfile:any;
urlCorrect:boolean;
intentosRealizados:number=0;
intentosPermitidos:number=3;
  constructor(
    private activatedRoute : ActivatedRoute,
    private _fuseConfigService: FuseConfigService,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private translateSrv: TranslateService,
    private wcp: WebCompProfileService,
) {
    this.activatedRoute.params.subscribe(params => {
      this.empresID = params['id'];
      console.log(this.empresID);
    });
    this._fuseConfigService.config = {
        layout: {
            navbar   : {hidden: true},
            toolbar  : {hidden: true},
            footer   : {hidden: true},
            sidepanel: {hidden: true},

        }
    };
    lang_surveyStatusV2.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
    });
  }

  ngOnInit(): void {

    this.getInfoWCPExternal();
  }

  validarAccesoWcp(){
    let faltantes= this.intentosPermitidos-this.intentosRealizados;
    let r = Math.random().toString(36).substring(7);
    console.log("cadena de datos aleatorios: ",r);
    let codigo=r;
    Swal.fire({
      title:this.translateSrv.instant('ACCIONES.MODALES.TIT_MOD_VALI_ACCE_WCP_EXT'),
      icon: 'info',
      // text: this.translateSrv.instant('ACCIONES.MODALES.PLA1_MOD_VALI_ACCE_WCP_EXT')+faltantes+this.translateSrv.instant('ACCIONES.MODALES.PLA2_MOD_VALI_ACCE_WCP_EXT'),
      input:'text',
      showCancelButton: true,
      reverseButtons: true,
      allowOutsideClick: false,
      cancelButtonText: this.translateSrv.instant('ACCIONES.MODALES.BTN_CAN'),
      confirmButtonText: this.translateSrv.instant('ACCIONES.MODALES.BTN_ACEP')
    })
    .then( (acceso) => {
      console.log(acceso);
      if (acceso.value==this.accesoWcp) {
        console.log('Ya lo valido el acceso');
        this.wcpValidado=true;
          this.modalGuardado();
        this.mostrarIframe();
        // setTimeout(() => {
        //   $('#RecDatos').submit();
        //   var scrollElem= document.querySelector('#Principal');
        //   scrollElem.scrollIntoView();
        //   // Swal.close();
        // },1000);
        // this.mostrarIframe();
      }
      else{
        console.log("error en la clave",this.intentosRealizados);

        this.intentosRealizados++;

          if(!acceso.dismiss){
            Swal.fire({
              title: '<font color="red">'+this.translateSrv.instant('ACCIONES.MODALES.WAR_ACCE_WCP_EXT')+'</font>',
              icon: 'info',
              showCancelButton: false,
              reverseButtons: true,
              // cancelButtonText: 'Cancelar',
              confirmButtonText: this.translateSrv.instant('ACCIONES.MODALES.BTN_ACEP')
            })
            .then( (result) => {
              console.log(result);
              if (result.value) {
              //   if (this.intentosRealizados>=3) {
              //     Swal.fire({
              //       title: this.translateSrv.instant('ACCIONES.MODALES.LIMI_ACCE_WCP_EXT'),
              //       icon: 'warning',
              //       reverseButtons: true,
              //       confirmButtonText: this.translateSrv.instant('ACCIONES.MODALES.BTN_ACEP'),
              //       confirmButtonColor: '#e40601'
              //     });
              // }else{

                this.validarAccesoWcp();
              // }
              }
            });
          }



      }
    });
  }

  modalGuardado(){
    let mensaje=this.translateSrv.instant('ACCIONES.MODALES.CHANGE_WCP');
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      showConfirmButton: false,
      imageUrl: 'https://app04.culturalgo.com/assetsCGO5/platform/img/loading.gif',
      imageWidth: 100,
      imageHeight: 60,
    });
  }

  mostrarIframe(){
    let claveIdioma =this.translateSrv.currentLang;
    console.log("entro perro",claveIdioma);
    let claveIdiomaDato:any;
    switch (claveIdioma) {
      case 'es':claveIdiomaDato='ES';break;
      case 'tr':claveIdiomaDato='TR';break;
      case 'en':claveIdiomaDato='EN';break;
      case 'zh1':claveIdiomaDato='ZH1';break;
      case 'zh2':claveIdiomaDato='ZH2';break;
      case 'pt':claveIdiomaDato='PT';break;
      case 'de':claveIdiomaDato='DE';break;
      case 'nl':claveIdiomaDato='NL';break;
      default:break;
    }

    this.wcp.getUrlWebComProfileExterno(this.empresID,claveIdioma).subscribe( (respuestaUrl:any) => {
      console.log('respuestaUrl',respuestaUrl);
      if(respuestaUrl.success == true){
        if (respuestaUrl.data.out_EditURL!=null) {
          this.urlWebComProfile = respuestaUrl.data.out_EditURL;
          this.urlCorrect=true;
            Swal.close();
          setTimeout(() => {
            $('#RecDatos').submit();
            // var scrollElem= document.querySelector('#Principal');
            // scrollElem.scrollIntoView();
            // Swal.close();
          },1000);
      //     this.cargandoInfoIframe=false;
      //     this.urlCorrect=true;

      //
      //   }else{
      //     this.cargandoInfoIframe=false;
      //     this.urlCorrect=false;
      //     this.textWarning=respuestaUrl.data.out_ResultText;
        }
      }else{
        // Swal.close();
      }
    });
  }

  getInfoWCPExternal(){
    this.wcp.getdataWPCExt(this.empresID).subscribe( (respuestaData:any) => {
      console.log('respuestaData',respuestaData);
      if (respuestaData.success) {
        this.accesoWcp=respuestaData.password;
        if (respuestaData.visibleWCP) {
          this.visibleWCP=2;
        }else{
          this.visibleWCP=1;
        }
        // this.visibleWCP=respuestaData.visibleWCP;
        if (this.visibleWCP==2) {
          this.validarAccesoWcp();
        }
      }
    });
  }

}
